module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-rostering-7a0cb0578124c2206daa00e1d4655990.svg";